/* Gift Packages — People-first flow with dynamic pricing + CRO */
(function () {
  'use strict';

  var root = document.getElementById('gp-root');
  if (!root) return;

  var dataEl = document.getElementById('gp-data');
  var CFG;
  try { CFG = JSON.parse(dataEl.textContent); }
  catch (e) { CFG = { demo: true }; }

  /* ── Variant lookup (single product with 15 variants) ── */
  var VARIANT_MAP = {};
  if (!CFG.demo && CFG.variants) {
    CFG.variants.forEach(function (v) {
      var key = v.option2 + '|' + v.option1;
      VARIANT_MAP[key] = v;
    });
  }

  function getVariant(pkgType, eyeIdx) {
    if (CFG.demo || !CFG.pkg_map) return null;
    var spauda = CFG.pkg_map[pkgType];
    /* Try multiple option1 formats to match different product setups */
    var simpleNum = String(eyeIdx + 1);
    var match = VARIANT_MAP[spauda + '|' + simpleNum];
    if (match) return match;
    /* Try all variants and find matching option2 + people count */
    if (CFG.variants) {
      var count = eyeIdx + 1;
      for (var i = 0; i < CFG.variants.length; i++) {
        var v = CFG.variants[i];
        if (v.option2 === spauda && v.option1 && v.option1.indexOf(String(count)) === 0) {
          return v;
        }
      }
    }
    return null;
  }

  /* ── Demo-mode fallback pricing (used only when no product linked) ── */
  var P = (CFG.pricing || {});
  var EYE1 = P.eye1 || 40;
  var EXTRA = P.extra_eye || 30;
  var CANVAS = P.canvas || 50;
  var GLASS = P.glass || 120;
  var BOX = P.box || 10;
  var DISC_MID = (P.middle_discount || 0) / 100;
  var DISC_BEST = (P.best_discount || 0) / 100;

  var BASE_PRICES = [EYE1, EYE1 + EXTRA, EYE1 + EXTRA * 2, EYE1 + EXTRA * 3, EYE1 + EXTRA * 4, EYE1 + EXTRA * 5, EYE1 + EXTRA * 6, EYE1 + EXTRA * 7];
  var PKG_ADDONS = { basic: 0, experience: CANVAS, premium: GLASS + BOX };
  var PKG_DISCOUNT = { basic: 0, experience: DISC_MID, premium: DISC_BEST };

  var PEOPLE_COUNTS = [1, 2, 3, 4, 5, 6, 7, 8];

  var PEOPLE_LABELS = {
    0: { count: '1 žmogui', price: '1 žmogui', name: '1 žmogaus' },
    1: { count: '2 žmonėms', price: '2 žmonėms', name: '2 žmonių' },
    2: { count: '3 žmonėms', price: '3 žmonėms', name: '3 žmonių' },
    3: { count: '4 žmonėms', price: '4 žmonėms', name: '4 žmonių' },
    4: { count: '5 žmonėms', price: '5 žmonėms', name: '5 žmonių' },
    5: { count: '6 žmonėms', price: '6 žmonėms', name: '6 žmonių' },
    6: { count: '7 žmonėms', price: '7 žmonėms', name: '7 žmonių' },
    7: { count: '8 žmonėms', price: '8 žmonėms', name: '8 žmonių' }
  };

  var selectedEyes = null;
  var packaging = {};

  root.addEventListener('click', function (e) {

    /* People button — check FIRST before anything else */
    var pbtn = e.target.closest('.gp-people-btn, .gp-people-pill:not(.gp-people-pill--more)');
    if (pbtn) {
      var idx = parseInt(pbtn.dataset.eyes, 10);
      if (isNaN(idx)) return;
      selectedEyes = idx;
      packaging = {};
      root.querySelectorAll('.gp-people-btn, .gp-people-pill').forEach(function (b) { b.classList.remove('selected'); });
      pbtn.classList.add('selected');
      updateAll();
      showPackages();
      return;
    }

    /* Tap peeking card edge to scroll to it */
    var cardEl = e.target.closest('.gp-card');
    if (cardEl && window.innerWidth <= 900 && !e.target.closest('.gp-card-cta') && !e.target.closest('.gp-accordion-toggle')) {
      var cardsWrap = root.querySelector('.gp-cards');
      if (cardsWrap) {
        var scrollTarget = cardEl.offsetLeft - cardsWrap.offsetLeft - 14;
        if (Math.abs(cardsWrap.scrollLeft - scrollTarget) > 30) {
          cardsWrap.scrollTo({ left: scrollTarget, behavior: 'smooth' });
          return;
        }
      }
    }

    var cta = e.target.closest('.gp-card-cta');
    if (cta) { handleBuy(cta); return; }


    /* People + button — add pill */
    if (e.target.id === 'gpPeopleMore' || e.target.closest('#gpPeopleMore')) {
      var row = root.querySelector('.gp-people-row');
      var plusBtn = document.getElementById('gpPeopleMore');
      if (!row || !plusBtn) return;
      var existing = row.querySelectorAll('.gp-people-pill:not(.gp-people-pill--more)');
      var count = existing.length;
      if (count >= 6) return;
      var newPill = document.createElement('button');
      newPill.className = 'gp-people-pill';
      newPill.dataset.eyes = String(count);
      newPill.textContent = String(count + 1);
      row.insertBefore(newPill, plusBtn);
      count++;
      if (count >= 6) plusBtn.style.display = 'none';
      return;
    }

    /* Package nav scroll */
    var pkgNav = e.target.closest('.gp-pkg-nav-btn');
    if (pkgNav) {
      var targetPkg = pkgNav.dataset.scroll;
      var targetCard = root.querySelector('.gp-card[data-pkg="' + targetPkg + '"]');
      if (targetCard) {
        targetCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    var accToggle = e.target.closest('.gp-accordion-toggle');
    if (accToggle) {
      var accBody = accToggle.nextElementSibling;
      var isOpen = accBody.classList.contains('open');
      accBody.classList.toggle('open');
      accToggle.textContent = isOpen ? 'Skaityti daugiau' : 'Slėpti';
      return;
    }

    var detailsToggle = e.target.closest('[data-details-toggle]');
    if (detailsToggle) {
      var panel = detailsToggle.nextElementSibling;
      if (!panel || !panel.classList.contains('gp-details-panel')) return;
      var open = detailsToggle.getAttribute('aria-expanded') === 'true';
      detailsToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) {
        panel.setAttribute('hidden', '');
      } else {
        panel.removeAttribute('hidden');
        /* Reset inner accordion: first section open, rest closed */
        var sections = panel.querySelectorAll('.gp-details-section');
        sections.forEach(function (s, idx) {
          if (idx === 0) s.classList.add('gp-details-section--open');
          else s.classList.remove('gp-details-section--open');
          var btn = s.querySelector('[data-section-toggle]');
          if (btn) btn.setAttribute('aria-expanded', idx === 0 ? 'true' : 'false');
        });
      }
      var label = detailsToggle.querySelector('.gp-details-link-label');
      if (label) label.textContent = open ? 'Daugiau apie patirtį / kuponą' : 'Slėpti';
      return;
    }

    /* Bottom "Slėpti" button inside the panel — collapses via the top toggle */
    var detailsClose = e.target.closest('[data-details-close]');
    if (detailsClose) {
      var closePanel = detailsClose.closest('.gp-details-panel');
      if (!closePanel) return;
      var topToggle = closePanel.previousElementSibling;
      while (topToggle && !topToggle.matches('[data-details-toggle]')) {
        topToggle = topToggle.previousElementSibling;
      }
      if (topToggle) {
        topToggle.click();
        topToggle.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    /* Inner accordion — only one section open at a time within a details panel */
    var sectionToggle = e.target.closest('[data-section-toggle]');
    if (sectionToggle) {
      var clickedSection = sectionToggle.closest('.gp-details-section');
      var parentPanel = sectionToggle.closest('.gp-details-panel');
      if (!clickedSection || !parentPanel) return;
      var wasOpen = clickedSection.classList.contains('gp-details-section--open');
      parentPanel.querySelectorAll('.gp-details-section').forEach(function (s) {
        s.classList.remove('gp-details-section--open');
        var b = s.querySelector('[data-section-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        clickedSection.classList.add('gp-details-section--open');
        sectionToggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    /* Review-photo lightbox */
    var revThumb = e.target.closest('[data-rev-modal]');
    if (revThumb) {
      var revModal = document.getElementById('gpRevModal');
      if (!revModal) return;
      var img = revModal.querySelector('.gp-rev-modal-img');
      img.src = revThumb.dataset.revImg || '';
      img.alt = revThumb.dataset.revName || '';
      var starsN = parseInt(revThumb.dataset.revRating || '5', 10);
      var starsStr = '';
      for (var si = 0; si < 5; si++) starsStr += si < starsN ? '★' : '☆';
      revModal.querySelector('.gp-rev-modal-stars').textContent = starsStr;
      var titleEl = revModal.querySelector('.gp-rev-modal-title');
      var tTitle = revThumb.dataset.revTitle || '';
      if (tTitle) { titleEl.textContent = tTitle; titleEl.style.display = ''; }
      else { titleEl.style.display = 'none'; }
      revModal.querySelector('.gp-rev-modal-text').textContent = revThumb.dataset.revText || '';
      revModal.querySelector('.gp-rev-modal-name').textContent = revThumb.dataset.revName || '';
      var locEl = revModal.querySelector('.gp-rev-modal-location');
      var tLoc = revThumb.dataset.revLocation || '';
      locEl.textContent = tLoc ? ', ' + tLoc : '';
      var timeEl = revModal.querySelector('.gp-rev-modal-time');
      var tTime = revThumb.dataset.revTime || '';
      timeEl.textContent = tTime ? ' · ' + tTime : '';
      revModal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      return;
    }

    var revModalCloser = e.target.closest('[data-rev-modal-close]');
    if (revModalCloser) {
      var closeModal = document.getElementById('gpRevModal');
      if (closeModal) closeModal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      return;
    }

    var faqBtn = e.target.closest('.gp-faq-q');
    if (faqBtn) {
      var item = faqBtn.closest('.gp-faq-item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.gp-faq-item.open').forEach(function (el) { el.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    }
  });

  function updateAll() {
    if (selectedEyes === null) return;
    var pCount = PEOPLE_COUNTS[selectedEyes] || 2;
    var labels = PEOPLE_LABELS[selectedEyes] || PEOPLE_LABELS[1];
    var lowestPP = 9999;

    /* Update people-count pill on every card (stays visible so user
       doesn't forget their selection after scrolling down). */
    root.querySelectorAll('[data-people-pill-text]').forEach(function (el) {
      el.textContent = 'Dovana ' + labels.count;
    });

    /* Dynamic digital-photo phrase in the details accordion */
    var _photoPhrase = pCount === 1
      ? '1 skaitmeninę akių nuotrauką'
      : pCount + ' skaitmenines akių nuotraukas';
    root.querySelectorAll('[data-pkg-photo-text]').forEach(function (el) {
      el.textContent = _photoPhrase;
    });

    root.querySelectorAll('.gp-card').forEach(function (card) {
      var pkg = card.dataset.pkg;
      var variant = getVariant(pkg, selectedEyes);
      var discountedPrice, fullPrice, savings;

      if (variant) {
        /* Variant prices from Shopify (in cents → euros) */
        discountedPrice = Math.round(variant.price / 100);
        fullPrice = variant.compare_at > 0 ? Math.round(variant.compare_at / 100) : discountedPrice;
        savings = fullPrice - discountedPrice;
      } else {
        /* Demo fallback: formula-based pricing */
        var base = BASE_PRICES[selectedEyes] || BASE_PRICES[0];
        fullPrice = base + (PKG_ADDONS[pkg] || 0);
        var discount = PKG_DISCOUNT[pkg] || 0;
        discountedPrice = discount > 0 ? Math.round(fullPrice * (1 - discount)) : fullPrice;
        savings = fullPrice - discountedPrice;
      }

      card.dataset.basePrice = discountedPrice;
      card.dataset.fullPrice = fullPrice;
      card.dataset.savings = savings;

      var numEl = card.querySelector('.gp-price-num');
      var savingsEl = card.querySelector('.gp-savings-num');
      var savingsPill = card.querySelector('.gp-savings-pill');
      var timerEl = card.querySelector('.gp-price-timer');

      /* Show discounted price immediately — no animation */
      if (numEl) numEl.textContent = discountedPrice;

      if (savingsPill) {
        if (savings > 0 && savingsEl) {
          savingsEl.textContent = savings;
          savingsPill.style.display = '';
        } else {
          savingsPill.style.display = 'none';
        }
      }

      if (timerEl) timerEl.style.display = 'none';

      var refEl = card.querySelector('.gp-ref-num');
      if (refEl) refEl.textContent = fullPrice;

      var refWrap = card.querySelector('.gp-card-refprice');
      if (refWrap) {
        if (savings > 0) {
          refWrap.classList.remove('gp-card-refprice--hidden');
          refWrap.style.display = '';
        } else {
          refWrap.classList.add('gp-card-refprice--hidden');
          refWrap.style.display = 'none';
        }
      }

      var pp = Math.round(discountedPrice / pCount);
      var ppEl = card.querySelector('.gp-perperson-num');
      var ppWrap = card.querySelector('.gp-card-perperson');
      if (ppEl) ppEl.textContent = pp;
      if (ppWrap) ppWrap.style.display = (pCount <= 1) ? 'none' : '';
      if (pp < lowestPP) lowestPP = pp;
    });

    root.querySelectorAll('.gp-people-label').forEach(function (el) {
      el.textContent = labels.count;
    });
    root.querySelectorAll('.gp-card-people-count').forEach(function (el) {
      el.textContent = labels.name + ' ';
    });
    root.querySelectorAll('.gp-price-people').forEach(function (el) {
      el.textContent = labels.price;
    });

    /* Fallback for the new layout where there are no .gp-card elements:
       compute the cheapest per-person price from the 3 standard packages
       directly (Shopify variants when available, demo formula otherwise). */
    if (lowestPP === 9999) {
      ['basic', 'experience', 'premium'].forEach(function (pkgKey) {
        var v = getVariant(pkgKey, selectedEyes);
        var price;
        if (v) {
          price = Math.round(v.price / 100);
        } else {
          var base = BASE_PRICES[selectedEyes] || BASE_PRICES[0];
          var full = base + (PKG_ADDONS[pkgKey] || 0);
          var disc = PKG_DISCOUNT[pkgKey] || 0;
          price = disc > 0 ? Math.round(full * (1 - disc)) : full;
        }
        var ppFb = Math.max(1, Math.round(price / pCount));
        if (ppFb < lowestPP) lowestPP = ppFb;
      });
    }

    var stickyPrice = document.querySelector('.gp-sticky-price');
    if (stickyPrice) stickyPrice.textContent = lowestPP;
  }

  function showPackages(noScroll) {
    var wrap = root.querySelector('.gp-packages-wrap');
    if (!wrap) return;
    wrap.classList.add('visible');
    if (!noScroll) {
      setTimeout(function () {
        var header = root.querySelector('.gp-packages .gp-step-header');
        if (header) header.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 120);
    }
  }

  function handleBuy(btn) {
    var card = btn.closest('.gp-card');
    var pkgKey = card.dataset.pkg;
    var originalText = btn.textContent;

    if (CFG.demo) {
      alert('Demo režimas — produktai neprijungti. Pridėkite produktus Shopify redaktoriuje.');
      return;
    }

    var variant = getVariant(pkgKey, selectedEyes);
    if (!variant) {
      alert('Produktas nerastas. Patikrinkite variantų nustatymus.');
      return;
    }

    btn.textContent = 'Pridedama...';
    btn.disabled = true;

    var items = [{ id: variant.id, quantity: 1 }];

    /* Check if physical packaging is selected */
    var bumpCheck = card.querySelector('.gp-bump-check');
    if (bumpCheck && bumpCheck.checked) {
      items.push({ id: 46715282227536, quantity: 1 });
    }

    fetch(CFG.urls.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart error');
      /* Trigger cart drawer/popup instead of redirect */
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      var cartDrawer = document.querySelector('cart-drawer, cart-notification, .cart-drawer, #cart-drawer, [data-cart-drawer]');
      if (cartDrawer && cartDrawer.open) { cartDrawer.open(); }
      else if (cartDrawer) { cartDrawer.classList.add('is-open', 'active'); document.body.classList.add('overflow-hidden'); }
      btn.textContent = originalText;
      btn.disabled = false;
    })
    .catch(function () {
      btn.textContent = 'Klaida — bandykite dar kartą';
      setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 2500);
    });
  }


  /* ── Sticky mobile bar ───────────────────────────────
     Anchor target: legacy 3-card layout used #packages; the current
     layout exposes #demo-picker. Fall back so the bar works in both.
     v-2026-05-09b */
  var stickyBar = document.getElementById('gpStickyBar');
  var cardsSection = document.getElementById('packages') || document.getElementById('demo-picker');

  if (stickyBar && cardsSection) {
    var stickyVisible = false;

    function checkSticky() {
      var rect = cardsSection.getBoundingClientRect();
      var shouldShow = rect.bottom < 0 && selectedEyes !== null;

      if (shouldShow && !stickyVisible) {
        stickyBar.classList.add('visible');
        stickyVisible = true;
      } else if (!shouldShow && stickyVisible) {
        stickyBar.classList.remove('visible');
        stickyVisible = false;
      }
    }

    window.addEventListener('scroll', checkSticky, { passive: true });

    stickyBar.querySelector('.gp-sticky-cta').addEventListener('click', function (e) {
      e.preventDefault();
      cardsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ── Scroll reveal (no-op) ───────────────────────────
     Scroll-reveal is disabled; content is always visible via CSS.
     Keeping a simple pass that adds .in-view so any external code
     relying on the class still works. */
  root.querySelectorAll('.gp-fade-up, .gp-hero').forEach(function (el) {
    el.classList.add('in-view');
  });

  /* ── Smooth scroll ─────────────────────────────────── */
  root.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      /* Prefer the section's step-label or section-title as the scroll anchor
         so CTAs land on visible copy instead of the padded section top. */
      var label = target.querySelector('.gp-step-label')
        || target.querySelector('.gp-section-title')
        || target;
      label.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ── Gallery scroll nav ───────────────────────────── */
  var galleryScroll = document.getElementById('gpGalleryScroll');
  var galleryPrev = document.getElementById('gpGalleryPrev');
  var galleryNext = document.getElementById('gpGalleryNext');
  var galleryDots = document.querySelectorAll('.gp-gallery-dot');

  function updateGalleryDots() {
    if (!galleryScroll || !galleryDots.length) return;
    var cards = galleryScroll.querySelectorAll('.gp-gallery-card');
    var scrollLeft = galleryScroll.scrollLeft;
    var closest = 0;
    var minDist = Infinity;
    cards.forEach(function (c, i) {
      var dist = Math.abs(c.offsetLeft - galleryScroll.offsetLeft - scrollLeft);
      if (dist < minDist) { minDist = dist; closest = i; }
    });
    galleryDots.forEach(function (d) { d.classList.remove('active'); });
    if (galleryDots[closest]) galleryDots[closest].classList.add('active');
  }

  if (galleryScroll) {
    var galleryTimer;
    galleryScroll.addEventListener('scroll', function () {
      clearTimeout(galleryTimer);
      galleryTimer = setTimeout(updateGalleryDots, 80);
    }, { passive: true });
  }

  if (galleryScroll) {
    galleryScroll.addEventListener('click', function (e) {
      var card = e.target.closest('.gp-gallery-card');
      if (!card) return;
      var scrollTarget = card.offsetLeft - galleryScroll.offsetLeft - 16;
      if (Math.abs(galleryScroll.scrollLeft - scrollTarget) > 20) {
        galleryScroll.scrollTo({ left: scrollTarget, behavior: 'smooth' });
      }
    });
  }

  if (galleryPrev) galleryPrev.addEventListener('click', function () {
    if (galleryScroll) galleryScroll.scrollBy({ left: -340, behavior: 'smooth' });
  });
  if (galleryNext) galleryNext.addEventListener('click', function () {
    if (galleryScroll) galleryScroll.scrollBy({ left: 340, behavior: 'smooth' });
  });

  /* ── Card image sliders ─────────────────────────────── */
  root.querySelectorAll('.gp-card-slider').forEach(function (slider) {
    var dotsWrap = slider.parentElement.querySelector('.gp-card-slider-dots');
    if (!dotsWrap) return;
    var dots = dotsWrap.querySelectorAll('span');
    var imgs = slider.querySelectorAll('img');

    var scrollTimer;
    slider.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var idx = Math.round(slider.scrollLeft / slider.offsetWidth);
        dots.forEach(function (d) { d.classList.remove('active'); });
        if (dots[idx]) dots[idx].classList.add('active');
      }, 60);
    }, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        slider.scrollTo({ left: i * slider.offsetWidth, behavior: 'smooth' });
      });
    });

    var leftArr = slider.parentElement.querySelector('.gp-card-slider-arrow--left');
    var rightArr = slider.parentElement.querySelector('.gp-card-slider-arrow--right');
    if (leftArr) leftArr.addEventListener('click', function () {
      slider.scrollBy({ left: -slider.offsetWidth, behavior: 'smooth' });
    });
    if (rightArr) rightArr.addEventListener('click', function () {
      slider.scrollBy({ left: slider.offsetWidth, behavior: 'smooth' });
    });
  });

  /* ── Coupon carousel dots ─────────────────────────── */
  root.querySelectorAll('.gp-coupon-slides').forEach(function (slider) {
    var slides = slider.querySelectorAll('.gp-coupon-slide');
    var dotsWrap = slider.parentElement.querySelector('.gp-coupon-dots');
    if (!dotsWrap || slides.length < 2) { if (dotsWrap) dotsWrap.style.display = 'none'; return; }
    slides.forEach(function (_, i) {
      var dot = document.createElement('span');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', function () {
        slider.scrollTo({ left: i * slider.offsetWidth, behavior: 'smooth' });
      });
      dotsWrap.appendChild(dot);
    });
    var dots = dotsWrap.querySelectorAll('span');
    var scrollTimer;
    slider.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var idx = Math.round(slider.scrollLeft / slider.offsetWidth);
        dots.forEach(function (d) { d.classList.remove('active'); });
        if (dots[idx]) dots[idx].classList.add('active');
      }, 60);
    }, { passive: true });
  });

  /* ── Coupon preview carousel arrows ────────────────── */
  root.querySelectorAll('.gp-cpv-carousel-wrap').forEach(function(wrap) {
    var slides = wrap.querySelector('.gp-coupon-slides');
    var leftArr = wrap.querySelector('.gp-cpv-arrow--left');
    var rightArr = wrap.querySelector('.gp-cpv-arrow--right');
    /* Hide arrows entirely when there's only 1 slide (nothing to navigate) */
    var slideCount = slides ? slides.querySelectorAll('.gp-coupon-slide').length : 0;
    if (slideCount < 2) {
      if (leftArr) leftArr.style.display = 'none';
      if (rightArr) rightArr.style.display = 'none';
      return;
    }
    if (slides && leftArr) {
      leftArr.addEventListener('click', function() {
        slides.scrollBy({ left: -slides.offsetWidth, behavior: 'smooth' });
      });
    }
    if (slides && rightArr) {
      rightArr.addEventListener('click', function() {
        slides.scrollBy({ left: slides.offsetWidth, behavior: 'smooth' });
      });
    }
  });

  /* ── Coupon preview tabs ──────────────────────────── */
  var cpvTabs = root.querySelectorAll('.gp-cpv-tab');
  var cpvPanels = root.querySelectorAll('.gp-cpv-panel');
  function cpvSyncVideos() {
    cpvPanels.forEach(function (p) {
      var videos = p.querySelectorAll('video');
      var isActive = p.classList.contains('active');
      videos.forEach(function (v) {
        if (isActive) {
          var pr = v.play();
          if (pr && typeof pr.then === 'function') pr.catch(function () { /* autoplay blocked — ignore */ });
        } else {
          try { v.pause(); } catch (_) {}
        }
      });
    });
  }
  cpvTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.dataset.cpv;
      cpvTabs.forEach(function (t) { t.classList.remove('active'); });
      cpvPanels.forEach(function (p) { p.classList.remove('active'); });
      tab.classList.add('active');
      var panel = root.querySelector('.gp-cpv-panel[data-cpv-panel="' + target + '"]');
      if (panel) panel.classList.add('active');
      cpvSyncVideos();
    });
  });
  /* Kick off once on init so the default-active panel's video plays */
  cpvSyncVideos();

  /* ── Reviews media carousel arrow ──────────────────── */
  var revMediaScroll = document.getElementById('gpRevMediaScroll');
  var revMediaNext = document.getElementById('gpRevMediaNext');
  if (revMediaScroll && revMediaNext) {
    revMediaNext.addEventListener('click', function () {
      revMediaScroll.scrollBy({ left: 400, behavior: 'smooth' });
    });
  }

  /* ── "Ar šis atsiliepimas naudingas?" helpful-button ────────────────
     Persists per-review votes in localStorage so clicking increments the
     count and the user can un-vote. Random seed makes each review start
     with 0–6 votes so it doesn't feel artificially empty. */
  (function () {
    var STORAGE_KEY = '_gpRevHelpful_v1';
    var votes = {};
    try { votes = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {}; } catch (e) {}
    function save() { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(votes)); } catch (e) {} }
    root.querySelectorAll('[data-rev-helpful]').forEach(function (btn) {
      var id = btn.getAttribute('data-rev-helpful');
      var rec = votes[id] || { base: Math.floor(Math.random() * 7), mine: 0 };
      votes[id] = rec;
      var countEl = btn.querySelector('.gp-rev-helpful-count');
      function paint() {
        var n = rec.base + (rec.mine || 0);
        if (countEl) countEl.textContent = n;
        btn.classList.toggle('gp-rev-helpful-btn--active', !!rec.mine);
      }
      paint();
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        rec.mine = rec.mine ? 0 : 1;
        save();
        paint();
      });
    });
    save();
  })();

  /* ── Reviews pagination + star filter ────────────────── */
  var revList = document.getElementById('gpRevList');
  var revPag = document.getElementById('gpRevPagination');

  if (revList && revPag) {
    var perPage = 2;  /* 2 per page → 4 pages for 8 reviews */
    var dataEl2 = document.getElementById('gp-data');
    if (dataEl2) {
      try {
        var d2 = JSON.parse(dataEl2.textContent);
        if (d2.reviews_per_page) perPage = d2.reviews_per_page;
      } catch(e) {}
    }

    var allRevCards = Array.prototype.slice.call(revList.querySelectorAll('.gp-rev-card'));
    var filteredRevCards = allRevCards.slice();
    var totalPages = Math.ceil(filteredRevCards.length / perPage);
    var currentPage = 1;

    function applyRevFilter() {
      var filterCbs = document.querySelectorAll('.gp-rev-filter-cb');
      var allCb = null;
      var starCbs = [];
      filterCbs.forEach(function(cb) {
        if (cb.dataset.star === 'all') { allCb = cb; }
        else { starCbs.push(cb); }
      });
      var activeStars = [];
      var anyStarChecked = false;
      starCbs.forEach(function(cb) {
        if (cb.checked) { activeStars.push(parseInt(cb.dataset.star, 10)); anyStarChecked = true; }
      });
      var showAll = !anyStarChecked || (allCb && allCb.checked);
      filteredRevCards = [];
      allRevCards.forEach(function(card) {
        var rating = parseInt(card.getAttribute('data-rev-rating'), 10);
        var visible = showAll || activeStars.indexOf(rating) !== -1;
        if (visible) { filteredRevCards.push(card); }
      });
      totalPages = Math.ceil(filteredRevCards.length / perPage);
      currentPage = 1;
      showRevPage(1);
    }

    function showRevPage(page) {
      currentPage = page;
      var start = (page - 1) * perPage;
      var end = start + perPage;
      allRevCards.forEach(function(card) { card.style.display = 'none'; });
      filteredRevCards.forEach(function(card, i) {
        card.style.display = (i >= start && i < end) ? '' : 'none';
      });
      renderRevPagination();
      /* Keep the user anchored at the pagination control — scroll the FIRST
         visible review card into view gently, not the whole section. This
         prevents the "jump to top" behavior when clicking next page. */
      if (page > 1) {
        var firstVisible = filteredRevCards[start];
        if (firstVisible) {
          var y = firstVisible.getBoundingClientRect().top + window.scrollY - 120;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }
    }

    function renderRevPagination() {
      if (totalPages <= 1) { revPag.innerHTML = ''; return; }
      var html = '';
      var maxVisible = 7;

      for (var p = 1; p <= totalPages; p++) {
        if (totalPages > maxVisible + 2) {
          if (p === 1 || p === totalPages || (p >= currentPage - 2 && p <= currentPage + 2)) {
            html += '<button class="' + (p === currentPage ? 'active' : '') + '" data-page="' + p + '">' + p + '</button>';
          } else if (p === currentPage - 3 || p === currentPage + 3) {
            html += '<span class="gp-rev-page-dots">…</span>';
          }
        } else {
          html += '<button class="' + (p === currentPage ? 'active' : '') + '" data-page="' + p + '">' + p + '</button>';
        }
      }
      revPag.innerHTML = html;
    }

    revPag.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-page]');
      if (btn) showRevPage(parseInt(btn.dataset.page, 10));
    });

    /* Star filter checkbox logic */
    var filterCbs = document.querySelectorAll('.gp-rev-filter-cb');
    filterCbs.forEach(function(cb) {
      cb.addEventListener('change', function() {
        var allCb = document.querySelector('.gp-rev-filter-cb[data-star="all"]');
        if (cb.dataset.star === 'all') {
          if (cb.checked) {
            filterCbs.forEach(function(c) { if (c.dataset.star !== 'all') c.checked = false; });
          }
        } else {
          if (allCb) allCb.checked = false;
          var anyChecked = false;
          filterCbs.forEach(function(c) { if (c.dataset.star !== 'all' && c.checked) anyChecked = true; });
          if (!anyChecked && allCb) allCb.checked = true;
        }
        applyRevFilter();
      });
    });

    showRevPage(1);
  }

  /* ── Countdown timer (15 min) ──────────────────────── */
  var _timerEnd = Date.now() + 15 * 60 * 1000;
  setInterval(function() {
    var remaining = Math.max(0, _timerEnd - Date.now());
    var mins = Math.floor(remaining / 60000);
    var secs = Math.floor((remaining % 60000) / 1000);
    var timeStr = mins + ':' + (secs < 10 ? '0' : '') + secs;
    root.querySelectorAll('.gp-timer-val').forEach(function(el) {
      el.textContent = timeStr;
    });
  }, 1000);

  /* ── Auto-select from URL params (?eyes=2&pkg=experience) or default ── */
  var _urlParams = new URLSearchParams(window.location.search);
  var _urlEyes = parseInt(_urlParams.get('eyes'), 10);
  var _urlPkg = _urlParams.get('pkg');

  var _startIdx = (_urlEyes >= 1 && _urlEyes <= 8) ? (_urlEyes - 1) : 1;
  selectedEyes = _startIdx;
  var defaultBtn = root.querySelector(
    '.gp-people-pill[data-eyes="' + _startIdx + '"], .gp-people-btn[data-eyes="' + _startIdx + '"]'
  );
  if (defaultBtn) defaultBtn.classList.add('selected');
  updateAll();
  showPackages(true);

  /* If package requested via URL, highlight it after a beat */
  if (_urlPkg) {
    setTimeout(function() {
      var targetCard = root.querySelector('.gp-card[data-pkg="' + _urlPkg + '"]');
      if (!targetCard) return;
      targetCard.classList.add('gp-card--highlight');
      targetCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function() { targetCard.classList.remove('gp-card--highlight'); }, 2200);
    }, 400);
  }

  /* ESC closes the review-photo lightbox */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var escModal = document.getElementById('gpRevModal');
    if (escModal && !escModal.hasAttribute('hidden')) {
      escModal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }
  });

  /* Review summary "Rodyti daugiau" collapse/expand (mobile only) */
  var _summaryToggle = root.querySelector('[data-rev-summary-toggle]');
  if (_summaryToggle) {
    var _summaryBody = _summaryToggle.closest('.gp-rev-summary-body');
    var _applyCollapse = function () {
      if (window.matchMedia('(max-width: 900px)').matches) {
        if (_summaryToggle.getAttribute('aria-expanded') !== 'true') {
          _summaryBody.classList.add('gp-rev-summary-collapsed');
        }
      } else {
        _summaryBody.classList.remove('gp-rev-summary-collapsed');
      }
    };
    _applyCollapse();
    window.addEventListener('resize', _applyCollapse);
    _summaryToggle.addEventListener('click', function () {
      var expanded = _summaryToggle.getAttribute('aria-expanded') === 'true';
      _summaryToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      _summaryToggle.firstChild.nodeValue = expanded ? 'Rodyti daugiau ' : 'Rodyti mažiau ';
      _summaryBody.classList.toggle('gp-rev-summary-collapsed', expanded);
    });
  }

})();
